import { ForecastModel } from '@app/common/static-data/models';
import { ModelId } from '../types';
import type { WeatherSummaryResult } from '../hooks/useWeatherSummary';

interface ModelInfo {
  label: string;
  color: string;
}

interface WeatherSummaryModelColumnProps {
  modelsWithData: ForecastModel[];
  modelSummaries: Record<ModelId, WeatherSummaryResult>;
  getModelInfo: (modelId: ModelId) => ModelInfo;
  showConsensusLabel?: boolean;
}

export function WeatherSummaryModelColumn({
  modelsWithData,
  modelSummaries,
  getModelInfo,
  showConsensusLabel = false,
}: WeatherSummaryModelColumnProps) {
  return (
    <div className="flex-shrink-0 w-24 sm:w-28 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 sticky left-0 z-20">
      {/* Header cell */}
      <div className="h-10 border-b border-gray-200 dark:border-gray-700 flex items-center justify-center px-1">
        <span className="text-xs font-semibold text-gray-500 dark:text-gray-400">Model</span>
      </div>

      {showConsensusLabel && (
        <div className="h-10 border-b border-gray-200 dark:border-gray-700 flex items-center justify-center px-2 bg-white dark:bg-gray-800">
          <span className="text-xs font-semibold text-pink-600 dark:text-pink-400">Consensus</span>
        </div>
      )}

      {/* Model rows */}
      {modelsWithData.map((modelId) => {
        const modelInfo = getModelInfo(modelId);
        return (
          <div
            key={modelId}
            className="h-24 border-b border-gray-200 dark:border-gray-700 flex items-center px-2 bg-white dark:bg-gray-800"
          >
            <div className="flex items-center gap-1.5 w-full">
              <div className="min-w-0 flex-1">
                <div className="text-xs font-bold text-gray-900 dark:text-gray-100 truncate">
                  {modelInfo.label}
                </div>
                {modelSummaries[modelId]?.statistics && (
                  <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    {modelSummaries[modelId].statistics!.temperature.min}°-
                    {modelSummaries[modelId].statistics!.temperature.max}°
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
